module.exports = __webpack_public_path__ + "img/v_hearts.0483da5b.png";